import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  isDescriptionHidden,
  isDateControl,
} from "@jsonforms/core";
import { Button } from "../../../../../../shadcn/components/ui/button";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

export const PropertyTypeRenderer = ({
  data,
  handleChange,
  path,
  schema,
  uischema,
}: ControlProps) => {
  const options = uischema?.options?.additionalData || [];
  const ctx = useJsonForms();
  const [customError, setCustomError] = useState("");

  const userData = useSelector((state: any) => {
    return state?.postYourProperty?.form?.[path];
  });

  const handleClick = (item: any) => {
    handleChange(path, item);
  };

  useEffect(() => {
    if (!data?.value)
      handleChange(path, { title: "Residential", value: "residential" });
  }, []);

  useEffect(() => {
    const errorData = ctx?.core?.errors;
    let flag = false;
    errorData?.forEach((error: any) => {
      if (error?.instancePath === "/" + path) {
        setCustomError(error?.message);
        flag = true;
      } else if (
        error?.instancePath === "" &&
        error?.params?.missingProperty === path
      ) {
        setCustomError("Required Field");
        flag = true;
      }
    });

    if (!flag) setCustomError("");
  }, [ctx?.core?.errors]);

  return (
    <div className="mt-8">
      <p className="font-openSans font-semibold text-mobile-body-lg lg:text-web-subheading leading-[22px] lg:leading-4 text-brand-bgBlack uppercase">
        {schema?.title}
      </p>
      <div className="flex flex-wrap gap-x-7 gap-y-5 mt-5">
        {options.map((item: any) => (
          <Button
            className={`text-brand-bgBlack relative font-openSans font-normal text-mobile-body-sm lg:text-web-body-md leading-4 rounded-full border hover:bg-brand-lightOrange px-9 w-[120px] lg:w-fit ${
              data?.value === item?.value ? "bg-brand-lightOrange" : "bg-white"
            }`}
            key={item?.value}
            onClick={() => handleClick(item)}
          >
            {item?.title}
          </Button>
        ))}
      </div>
      {customError && (
        <label
          htmlFor="name"
          className={"text-brand-textRed text-web-body-sm ml-4"}
        >
          {customError}
        </label>
      )}
    </div>
  );
};

export default withJsonFormsControlProps(PropertyTypeRenderer);
